import React from 'react';
import './awards.scss';

import award2026 from '../../images/awards/award-plaque-BR603510 -2026.png';
import award2025 from '../../images/awards/award-plaque-BR603860-digital-2025.png';
import award2024 from '../../images/awards/award-plaque-BR603870-2024.png';

const awards = [
    {
        year: '2026',
        image: award2026,
        alt: 'BusinessRate Best of 2026 award winner plaque for Family Eco Dental in Union City, New Jersey',
        detail: 'BusinessRate Best of 2026',
    },
    {
        year: '2025',
        image: award2025,
        alt: 'BusinessRate Best of 2025 award for Family Eco Dental, with Google Reviews recognition from August 2025',
        detail: 'BusinessRate Best of 2025',
    },
    {
        year: '2024',
        image: award2024,
        alt: 'BusinessRate Best of 2024 award for Family Eco Dental, with Google Reviews recognition from November 2024',
        detail: 'BusinessRate Best of 2024',
    },
];

function AwardsSection() {
    return (
        <section className="section-sp1 awards-section" aria-labelledby="awards-title">
            <div className="container">
                <div className="awards-intro heading-bx text-center">
                    <h6 className="title-ext text-secondary">A thank-you to our community</h6>
                    <h2 className="title" id="awards-title">Three years of local recognition</h2>
                    <p>
                        Family Eco Dental has been recognized as a BusinessRate Best of dentist in Union City
                        for three consecutive years. These awards reference Google Reviews and reflect the trust
                        our patients place in our team.
                    </p>
                </div>
                <div className="row awards-gallery">
                    {awards.map((award) => (
                        <div className="col-lg-4 col-md-6" key={award.year}>
                            <figure className="award-item">
                                <img src={award.image} alt={award.alt} loading="lazy" />
                                <figcaption>
                                    <h3>{award.detail}</h3>
                                    <p>Union City, New Jersey</p>
                                </figcaption>
                            </figure>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default AwardsSection;